import { Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  compressImageFile,
  customValidation,
  EPhone,
  formatPhoneNumber,
  Method,
  updateMainHeader,
  validations,
} from "../../commonFunctions/CommonFunctions";
import http from "../../commonFunctions/httpClient";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import {
  HeaderList,
  IHeaderListActions,
} from "../../Components/Header/HeaderList";
import WSPhone from "../../Components/Phone/WSPhone";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { WSHeaderCard } from "../../Components/View/HeaderCard";
import config from "../../Config/config.json";
import WSButton from "../../Components/Button/WSButton";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

const VendorProfile: React.FC<any> = React.memo((props) => {
  const { showMessage } = useSnackbar();
  const { register, handleSubmit, control, setValue, watch, reset, getValues } =
    useForm();
  const navigate = useNavigate();
  const params = useParams();
  const [imageUrl, setImageUrl] = useState<any>([]);
  const [VendorData, setVendorData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaded, setloaded] = useState<boolean>(true);
  const [userData, setUserData] = useState<any>(null);
  const id = params?.id;
  const VendorUserId: any = params?.userId;
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  // const [selectedDocuments, setSelectedDocuments] = useState<File | null>(null);
  const { fields, append, remove, replace } = useFieldArray({
    name: "items",
    control,
  });
  breadCrumbsStore.updateBreadCrumbs([
         { "Vendors": "Vendors" }
     ]);
  useEffect(
    () => () => {
      reset();
    },
    []
  );

  useEffect(() => {
    append({
      startTime: "",
      endTime: "",
      day: "",
    });
  }, []);

  useEffect(() => {
    /**
     * Method to get the user record by id for edit purpose
     * @param id
     */

    async function getUserById(): Promise<void> {
      try {
        const response: any = await http.get(`Auth/${VendorUserId}`);
        if (response) {
          setUserData(response);
          for (const field in response) {
            if (field === "phoneNumber") {
              setValue(
                field,
                formatPhoneNumber((response as any)[field], EPhone.AddHyphen)
              );
            } else {
              setValue(field, (response as any)[field]);
            }
          }
          setValue("name", response?.name);
        }
      } catch (error) {
        showMessage("Error fetching user:", "error");
      }
    }
    if (VendorUserId) {
      getUserById();
    }
  }, [VendorUserId]);
  const vendorTypeSouse = {
    url: "VendorTypeMaster/search",
    page: 1,
    pageSize: 100000,
    filter: [],
    sort: [],
  };
  const vendorServiceSource = {
    url: "VendorService/search",
    page: 1,
    pageSize: 100000,
    filter: [],
    sort: [],
  };
  const serviceSource = {
    url: "VendorService/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };


    useEffect(() => {
        updateMainHeader("Vendor");
      });
    
      breadCrumbsStore.updateBreadCrumbs([
        { "Vendor": `/contact/list/${2}` },
        { [!id ? "Add Vendor " : "Update Vendor "]: "/vendor/profile/add/:userId" },
      ]);
      
  useEffect(() => {
    /**
     * Method to get the user record by id for edit purpose
     * @param id
     */
    async function getVendorById(id: any): Promise<void> {
      try {
        setloaded(false);
        const response: any = await http.get(`VendorProfile/user/${id}`); //callAPI
        if (response && response.data) {
          setVendorData(response.data);
          for (const field in response.data) {
            if (field === "phoneNumber") {
              setValue(
                field,
                formatPhoneNumber(
                  (response?.data as any)[field],
                  EPhone.AddHyphen
                )
              );
            } else if (field === "profileImageUrl") {
              setImageUrl(
                `${config.imgUrl}${response?.data[field].replace(
                  "UploadedImages/",
                  ""
                )}`
              );
            } else {
              setValue(field, (response?.data as any)[field]);
            }
          }
          setValue("GSTNumber", response.data?.gstNumber);
        }
      } catch (error) {
        showMessage("Error fetching schedule:", "error");
      }
    }
    if (id) {
      getVendorById(id);
    }
  }, [id]);

  const handleCancelClick = () => {
    navigate(`/contact/list/${2}`);
  };
  const handleUploadChange = async (uploadedFile: any) => {
    const file: any = uploadedFile[0];
    try {
      let newFile: any = await compressImageFile(uploadedFile);
      setSelectedFile(newFile);
    } catch (error) {
      showMessage("Error converting file to base64:", "error");
    }
  };

  /**
   * Method for Add/Update the data
   * @param data
   */
  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const request: any = await setRequest(data);
      if (id && VendorData?.id) {
        const response: any = await callAPI(
          `VendorProfile/${VendorData?.id}`,
          Method.PUTFORMDATA,
          null,
          null,
          request
        );
        if (response) {
          if (response.success === true) {
            showMessage(
              response?.message,
              response.success === true ? "success" : "error"
            );
            response.success === true && navigate(`/contact/list/${2}`);
          }
        }
      } else {
        const response: any = await callAPI(
          "VendorProfile",
          Method.POSTFORMDATA,
          null,
          null,
          request
        );
        if (response) {
          if (response.success === true) {
            showMessage(
              response?.message,
              response.success === true ? "success" : "error"
            );
            response.success === true && navigate(`/contact/list/${2}`);
          }
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };

  const setRequest = async (data: any) => {
    try {
      const formData = new FormData();
      if (selectedFile) {
        formData.append("profileImage", selectedFile!);
      }
      // if (selectedDocuments) {
      //     formData.append("documents", selectedDocuments!);
      // }
      formData.append("userId", VendorUserId || id);
      formData.append("name", data.name);
      formData.append("VendorTypeId", data?.vendorTypeId);
      formData.append(
        "phoneNumber",
        formatPhoneNumber(data?.phoneNumber, EPhone.RemoveHyphen)
      );
      formData.append("companyName", data.companyName);
      formData.append("email", data?.email);
      formData.append("licenceNumber", data?.licenceNumber);
      formData.append("GSTNumber", data?.GSTNumber);
      formData.append("panNumber", data?.panNumber);
      formData.append("addressLine1", data.addressLine1);
      formData.append("addressLine2", data?.addressLine2);
      formData.append("state", data.state);
      formData.append("city", data.city);
      formData.append("pincode", data.pincode);
      formData.append("websiteUrl", data?.websiteUrl);
      formData.append("experience", data?.experience);

      return formData;
    } catch (e: any) {
      showMessage(e.error);
    }
  };
  

  const transFormDataVendorType = (data: any) => {
    const qualifications: Array<any> = [];
    if (data) {
      data.map((item: any) => {
        qualifications.push({ label: item.typeName, value: item.id });
      });
    }
    return qualifications;
  };

  // const handleUploadFile = (file: any) => {
  //     // setDefaultImg(null)
  //     if (file && file.length > 0) {
  //         setSelectedDocuments(file);
  //     }
  // }
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
                minHeight: "100%",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Basic Information{" "}
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    disabled
                    control={control}
                    id="name"
                    name="name"
                    rules={{ required: true }}
                    label="Name *"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="email"
                    {...register("email")}
                    name="email"
                    rules={customValidation(true, validations.email)}
                    label="Email *"
                    disabled
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSPhone
                    label="Phone"
                    rules={{ required: true }}
                    control={control}
                    id="phoneNumber"
                    {...register("phoneNumber")}
                    name="phoneNumber"
                    disabled
                  ></WSPhone>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
                minHeight: "100%",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Address Information{" "}
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="addressLine1"
                    name="addressLine1"
                    rules={{ required: true }}
                    label="Address Line1 *"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="addressLine2"
                    name="addressLine2"
                    rules={{ required: false }}
                    label="Address Line2 "
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="state"
                    name="state"
                    rules={{ required: true }}
                    label="State *"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="city"
                    name="city"
                    rules={{ required: true }}
                    label="City *"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="pincode"
                    name="pincode"
                    rules={{ required: true }}
                    label="Pincode *"
                    maxLength={6}
                  ></WSTextField>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
                minHeight: "100%",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Additional Information
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSSelectField
                    rules={{ required: false }}
                    {...register("vendorTypeId")}
                    id="vendorTypeId"
                    control={control}
                    source={vendorTypeSouse}
                    transFormData={transFormDataVendorType}
                    label="Vendor Type"
                    name="vendorTypeId"
                    // multiple={true}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="companyName"
                    name="companyName"
                    rules={{ required: true }}
                    label="Company Name *"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="licenceNumber"
                    name="licenceNumber"
                    rules={{ required: true }}
                    label="Licence Number "
                  ></WSTextField>
                </Grid>

                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="GSTNumber"
                    name="GSTNumber"
                    rules={{ required: true }}
                    label="GST Number "
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="panNumber"
                    name="panNumber"
                    rules={{ required: true }}
                    label="Pan Number "
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="websiteUrl"
                    name="websiteUrl"
                    rules={{ required: true }}
                    label="Website Url "
                  ></WSTextField>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
                minHeight: "100%",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Profile
                  </Typography>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Grid container alignItems="center" spacing={2}>
                    {/* Image Upload - left side */}
                    <Grid item>
                      <WSImageUpload
                        control={control}
                        id="profileImage"
                        name="profileImage"
                        label="Profile Image"
                        rules={{ required: false }}
                        onChange={handleUploadChange}
                        imgUrl={imageUrl}
                      />
                    </Grid>

                    {/* Name - right side, vertically centered */}
                    <Grid item sx={{ mt: 2 }}>
                      <Typography sx={{ fontSize: "0.875rem", color: "gray" }}>
                        {VendorData?.name}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                {VendorData && (
                  <Grid item sm={8} xs={12}>
                    <Grid item container spacing={1} alignItems="center">
                      <Grid item>
                        <WSIcons.PhoneIcon
                          sx={{ fontSize: "0.875rem", mt: 1 }}
                        />
                      </Grid>
                      <Grid item>
                        <Typography
                          sx={{ fontSize: "0.875rem", color: "gray" }}
                        >
                          {VendorData?.phoneNumber}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item container spacing={1} alignItems="center">
                      <Grid item>
                        <WSIcons.EmailIcon
                          sx={{ fontSize: "0.875rem", mt: 1 }}
                        />
                      </Grid>
                      <Grid item>
                        <Typography
                          sx={{ fontSize: "0.875rem", color: "gray" }}
                        >
                          {VendorData?.email ? VendorData?.email : "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            spacing={2} 
            sx={{ mt: 2 }}
          >
            <Grid item>
              <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#098963",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Grid>

            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save"
                size="medium"
                variant="outlined"
                color="primary"
                onClick={handleSubmit(onSubmit)}
                loading={loading}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
});

export default VendorProfile;
